import { Component } from '@angular/core';
import {QuickCardComponent} from "../../../core/quick-card/quick-card.component";
import {Observable} from "rxjs";
import {ApiService, OverviewMetrics} from "../../../services/api.service";
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
  selector: 'tenants-quick-card',
  standalone: true,
  imports: [
    QuickCardComponent,
    MatTooltipModule
  ],
  templateUrl: './tenants-quick-card.component.html'
})
export class TenantsQuickCardComponent {
  loader?: Observable<OverviewMetrics>

  constructor(readonly api:ApiService) {}

  ngOnInit(): void {
    this.loader = this.api.getTenantsOverview()
  }
}

